import { company } from '~/company/Company';

const config = () => ({
  stepsData: [
    {
      position: 'bottom',
    },
    {
      position: 'bottom',
    },
    {
      position: 'top',
    },
    {
      position: 'top',
    },
    {
      position: 'top',
    },
    {
      position: 'top',
    },
    {
      position: 'top',
    },
    {
      position: 'top',
    },
    {
      position: 'top',
    },
  ],
});

export default () => ({
  ...config(),
  stepsData: config().stepsData.map((configItem, index) => ({
    ...configItem,
    img: company.images.onboarding?.[index] || '',
  })),
});
